import React, { useContext, useEffect, useState } from "react";
import SellerSidebar from "../../navigation/sellerNavigation";
import { getData } from "../../fetchRoutes/getData";
import BarChart from "./charts/barChart";
import WordCloudChart from "./charts/wordCloudChart";
import PieChart from "./charts/pieChart";
import ScatterChart from "./charts/scatterChart";
import SellerMobileSidebar from "../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../context/deviceContext";

export default function SellerDashboardContainer() {
  
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const sellerAnalyticsUrl = process.env.REACT_APP_SELLER_ANALYTICS;

  const {isMobile}= useContext(DeviceContext);


  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoading(true);
      try {
        const response = await getData(sellerAnalyticsUrl);
        if (response.status === "success") {
          setAnalytics(response.data);
        } else {
          setError("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [sellerAnalyticsUrl]);

  return (
    <div className="sellerDashboard">
      {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
      <div className="container moreProperties">
        <h1 className="containerTitle">MY DASHBOARD</h1>
        {loading && 
          <div className="loaderContainer">
            <div className="loader"></div>
            <p className="loadingText">Loading data...</p>
          </div>
        }
        {error && <p style={{ color: "red" }}>{error}</p>}

        {analytics && (
          <div className="chartGrid">
            <BarChart data={analytics.bidPerProperty} />
            <WordCloudChart data={analytics.wordCloud} />
            <PieChart data={analytics.bidStats} />
            <ScatterChart data={analytics.bidsOverTime} />
          </div>
        )}
      </div>
    </div>
  );
}
